module.exports = __webpack_public_path__ + "img/41_6.d072afe9.png";